  <div [ngClass]="selectedText !='' ? 'vm-switch-box vm-secondary-switch-box' : 'vm-secondary-switch'">
    <input class="vm-switch-checkbox" (focus)='onTouched()' type="checkbox" name="{{name}}" id="chk_{{name}}" value="value"
           [disabled]="disabled" (change)='switchchange($event)' [(ngModel)]='value'>
    <label class="vm-switch-label" for="chk_{{name}}" [style]="style">
      <span class="vm-switch-on">{{ selectedText != "" ? selectedText : "" }}</span>
      <span class="vm-switch-off">{{ deselectedText != "" ? deselectedText: "" }}</span>
    </label>
  </div>
                      
